import { render, staticRenderFns } from "./ButtonNotifyMe.vue?vue&type=template&id=16c0a808&"
import script from "./ButtonNotifyMe.vue?vue&type=script&lang=ts&"
export * from "./ButtonNotifyMe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports